import React from 'react'

import { CoinStore } from '../stores/CoinStore'
import LayoutPicker from './LayoutPicker'

export default class CoinPicker extends React.Component {
  state = {
    coins: [], // a list of strings
    filter: '', // value entered in the search box
    selectedCoin: null,
    showLayoutPicker: false,
  }

  componentDidMount() {
    var coins = CoinStore.getCurrencies()
    this.setState({coins})

    if (this.searchInput) this.searchInput.focus()
  }

  componentDidUpdate() {
    if (this.searchInput) this.searchInput.focus()
  }

  setCoin = (c) => {
    if (this.props.onCoinSelect) {
      return this.props.onCoinSelect(c)
    }
    
    // ask user to choose which window to plot this coin
    this.setState({selectedCoin: c, showLayoutPicker: true})
  }

  prettify(symbol) {
    const [a, b] = symbol.split('_')
    return b + a
  }

  row = (c) => {
    // check if we are on charts or calculator
    var href = this.props.onCoinSelect ? '#calculator' : '#charts'
    return (
      <li key={c} className='bb b--light-silver'>
        <a className="f5 db pa2 link hover-dark-red" href={href}
          onClick={() => this.setCoin(c)}>
          {this.prettify(c)}
        </a>
      </li>
    )
  }

  list = (coins) => {
  	return (
  		<ul className='list pl0 ma0 b--light-silver br2'>
  			{coins.map(c => {
        return this.row(c)
      })}
  		</ul>
  	)
  }

  filter = (e) => {
    var text = e.target.value.toUpperCase()
    this.setState({filter: text})
  }

  handleEscapeKey = (e) => {
    if (e.keyCode === 27) {
      this.props.onCancel()
    }
  }

  render() {
    let {coins, filter, showLayoutPicker} = this.state

    if (showLayoutPicker) {
      return <LayoutPicker
        symbol={this.state.selectedCoin}
        onCancel={() => this.setState({showLayoutPicker: false})}
        onSelect={(layout) => {
          this.props.onSelect(this.state.selectedCoin, layout)
        }}
      />
    }

    if (filter) {
      coins = coins.filter(c => {
        const prettified = this.prettify(c)
        return prettified.startsWith(filter)
      }, [])
    }
    
    return (
      <div className='absolute coin-picker z-index-100 shadow-2'>
        <div className='w-10'>
          <button className='bg-animate' onClick={this.props.onCancel}>Cancel</button>
        </div>
        <div className='w-100 pa2'>
          <input ref={(input) => { this.searchInput = input }}
            onKeyDown={this.handleEscapeKey}
            onChange={this.filter}
            className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" />
        </div>
        <div className='h-75 overflow-y-auto'>
          { this.list(coins) }
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/CoinPicker.js